import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { Repo } from "types/generated";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import TableCellLink from "ds/components/Table/Row/CellLink";
import { getRepoUrl } from "utils/spaceliftRepo";

const SpaceliftVcsReposTableNameCell = ({
  item: repo,
  ...cellProps
}: TableSimpleCellProps<Repo>) => {
  const repoUrl = getRepoUrl(repo.id);

  return (
    <TableSimpleCell {...cellProps} role="rowheader">
      <TableCellLink href={repoUrl}>{repo.name}</TableCellLink>
    </TableSimpleCell>
  );
};

export default SpaceliftVcsReposTableNameCell;
